// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__j883c","projectsContainer":"Projects_projectsContainer__rEc3y","projectsElements":"Projects_projectsElements__bfxig"};